import axios from "axios"

export const svDataMonth = () => {
    return axios.get(`graph/data/month`).then((res) => res).catch((error) => error);
}

export const svDataDays = () => {
    return axios.get(`graph/data/day`).then((res) => res).catch((error) => error);
}